const CybersecData = [
  {
    core: [
      {
        id: "1",
        name: "Introduction to Cybersecurity",
        karma: "200",
        description:
          "Are you new to IT & cybersecurity and wondering which role might suit you best? In this cybersecurity for beginners overview, we cover the roles of Network Administrator, Incident Responder, System Administrator, Penetration Tester, Cloud Engineer, Cybersecurity Manager, and Privacy Analyst. Find the role for you in this exciting field.",
        link: "https://app.cybrary.it/browse/course/introduction-to-it-and-cybersecurity/",
        inner_description:
          "After course completion, share the certificate in #cybersecurity channel with hashtag #cl-cybersecurity-intro to avail 200 Karma Points",
        example:
          "#cl-cybersecurity-intro Hey I’ve completed the Introduction to Cybersecurity course. Here’s my certificate.",
      },
      // {
      //   id: "2",
      //   name: "Android Basics with Compose",
      //   karma: "400",
      //   description:
      //     "In this course, you'll learn the basics of building Android apps with Jetpack Compose, the new UI toolkit for building Android apps. Along the way, you'll develop a collection of apps to start your journey as an Android developer.",
      //   link: "https://developer.android.com/courses/android-basics-compose/course",
      //   inner_description:
      //     "After course completion, share the 4 badges you’ve earned in #android-development channel of the µLearn Discord server with the hashtag #android-compose to avail karma points.",
      // },
    ],
    sub: [
      //   {
      //     id: "1",
      //     name: "Git and GitHub",
      //     karma: "200",
      //     description:
      //       "Git is a piece of software that makes it simpler to manage different versions of your own software in a software repository.  GitHub is a place to share software repositories and collaborate with other developers. These tools make it easier for multiple people to work on the same software project. In this course you will learn about: Installing Git, Creating a Git Repository, Cloning a Git Repository, Adding and Removing from a Git repository, Using GitHub, creating pull requests, branching repositories, merging repositories.By the end of the course, you'll know way more about Git than the people in this web comic. :)",
      //     link: "https://www.youtube.com/watch?v=RGOj5yH7evk",
      //     inner_description:
      //       "Now if you go to the pull requests tab in GTech µLearn repo, you’ll be able to see your pull request. Open it and copy your pull request URL.",
      //     example:
      //       "Submit the link in #android-development channel with the hashtag, #android-git-github" at the beginning,
      //     assignment: [
      //       {
      //         assignment_description:
      //           "Just like knowing how to use the Command Line, Git & Github will be very important in your daily workflow as a programmer / developer. Let’s put your Git and Github skills to practice! Find the assignment below.",
      //         assignment_inner_description: "",
      //         link: "https://mulearn.notion.site/Assignment-6cc865e1fc85409d985fd64a4a05519a",
      //       },
      //     ],
      //   },
    ],
  },
]

export default CybersecData
